export default "__VITE_ASSET__yMOu5p_w__"